import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import { featuredMapInvestors } from '../home/newsFeed';
import featured from '../home/getFeatured';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

import './featured.less';

const Featured = () => {
  const { country } = useGlobalData();
  const { t } = useTranslation();
  const newsForCountry = Object.values(featuredMapInvestors)
    .map((feature) => {
      if (feature.countries.includes(country)) return feature;
    })
    .filter((el) => el != null);

  return (
    <div className="o-investors">
      <div className="m-globalContentContainer">
        <div className="m-investors__container">
          <div className="m-investors__banner m-investors__inv__banner m-investors__combinig --padding --gray">
            <p className="m-featured__text__title">
              <Trans i18nKey="web.home.featured.title" />
            </p>
            <div className="m-investors__banner m-investors__centered">
              {newsForCountry.map((feature) => (
                <div className="m-investors__text" key={feature.name}>
                  <a
                    className="m-featured_investor__imageContainer"
                    href={feature.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Featured In ${feature.name}`}
                  >
                    <GatsbyImage
                      image={featured(feature.img)}
                      className="a-featured_investor__image"
                      alt={t('images.name.logo.alt', { name: feature.alt })}
                      title={t('images.press.logo.title')}
                    />
                  </a>
                  {/* <Icon name="client" className="a-investors__combinig__icon" />
    <h2 className="m-investors__text__title --no-border"><Trans i18nKey="web.ivestors.invest.combining.good.client" /></h2>
    <p className="m-investors__text__brand_normal"><Trans i18nKey="web.ivestors.invest.combining.fast" /></p> */}

                  <a
                    className="m-featured_investor__imageContainer_description"
                    // key={feature.name}
                    href={feature.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Featured In ${feature.name}`}
                  >
                    <p>{feature.description}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
